import type { AllianceBranding } from '@/lib/api';
import { cn } from '@/lib/utils';

/** Alliance logo, or a tag monogram when none is uploaded. */
export default function AllianceLogo({
  alliance,
  className,
}: {
  alliance: Pick<AllianceBranding, 'name' | 'tag' | 'logoUrl'> | null | undefined;
  className?: string;
}) {
  if (alliance?.logoUrl) {
    return <img src={alliance.logoUrl} alt={alliance.tag ?? alliance.name} className={cn('w-auto rounded', className)} />;
  }
  const label = (alliance?.tag || alliance?.name || '?').slice(0, 4);
  return (
    <div
      className={cn(
        'flex aspect-square items-center justify-center rounded bg-slate-800 text-xs font-bold text-orange-400',
        className,
      )}
    >
      {label}
    </div>
  );
}
